var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.initialized && _vm.materialLists.length === 0
        ? _c("b-alert", { attrs: { variant: "warning", show: "" } }, [
            _c("strong", [_vm._v("Achtung:")]),
            _vm._v(
              " Es wurde noch keine Materiallisten für diese Fahrt hinterlegt! Normalerweise sollte für\n    eine Fahrt immer eine für die Unterkunft und/oder die Art der Fahrt passende Materialliste ausgewählt werden.\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "8" } },
            [
              _c("strong", [_vm._v("Materiallisten:")]),
              _vm._v(" "),
              _vm._l(_vm.materialLists, function (list, index) {
                return _c("span", [
                  _c("a", { attrs: { href: list.url } }, [
                    _vm._v("\n          " + _vm._s(list.text)),
                    index + 1 < _vm.materialLists.length
                      ? _c("span", [_vm._v(", ")])
                      : _vm._e(),
                  ]),
                ])
              }),
              _vm._v(" "),
              _vm.initialized && _vm.materialLists.length === 0
                ? _c("span", [
                    _vm._v("Es wurden keine Materiallisten ausgewählt, "),
                    _c("a", { attrs: { href: _vm.tripEditUrl } }, [
                      _vm._v("ändern"),
                    ]),
                    _vm._v("."),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "b-btn-group",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "sm",
                        variant: "outline-primary",
                        disabled: _vm.isBusy,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-sync-alt" }),
                      _vm._v(" Aktualisieren\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.item-add-dialog",
                          modifiers: { "item-add-dialog": true },
                        },
                      ],
                      attrs: {
                        size: "sm",
                        variant: "outline-success",
                        disabled: _vm.isBusy,
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-plus" }),
                      _vm._v(" Hinzufügen\n        "),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("AddItemDialog", {
                attrs: {
                  items: _vm.items,
                  "filter-options": _vm.filterOptions,
                  "api-url": _vm.apiUrl,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-table",
        {
          attrs: {
            striped: "",
            hover: "",
            busy: _vm.isBusy,
            items: _vm.filteredItems,
            fields: _vm.fields,
            "sort-compare": _vm.sortCompare,
            "tbody-tr-class": _vm.rowClass,
            stacked: "sm",
            small: "",
            bordered: "",
            "head-variant": "dark",
          },
          on: {
            "update:busy": function ($event) {
              _vm.isBusy = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "cell(shopping_place)",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "b-btn-group",
                    { staticClass: "float-right d-sm-none" },
                    [
                      item.is_shopped
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "save-row-toggle",
                              attrs: {
                                size: "xs",
                                variant: "primary",
                                disabled: item._updating,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleIsShopped(item)
                                },
                              },
                            },
                            [
                              !item._updating
                                ? _c("i", { staticClass: "fas fa-undo" })
                                : _vm._e(),
                              _vm._v(" "),
                              item._updating
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "light" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.is_shopped
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "save-row-toggle",
                              attrs: {
                                size: "xs",
                                variant: "success",
                                disabled: item._updating,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleIsShopped(item)
                                },
                              },
                            },
                            [
                              !item._updating
                                ? _c("i", { staticClass: "fas fa-check" })
                                : _vm._e(),
                              _vm._v(" "),
                              item._updating
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "light" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { size: "xs" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleDetails(item)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-edit" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formatShoppingPlace(item.shopping_place)) +
                      "\n      "
                  ),
                  _c("span", { staticClass: "d-md-none" }, [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.formatIngredientCategory(item.ingredient_category)
                        ) +
                        ")"
                    ),
                  ]),
                ]
              },
            },
            {
              key: "cell(ingredient_title)",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "float-right d-sm-none" }, [
                    item.amount_needed !== item.amount_shopping
                      ? _c("span", { staticClass: "item-original-amount" }, [
                          _vm._v(
                            "\n          (" +
                              _vm._s(
                                _vm.formatAmountNeeded(
                                  item.amount_needed,
                                  "amount_needed",
                                  item
                                )
                              ) +
                              ")"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatAmountNeeded(
                            item.amount_shopping,
                            "amount_shopping",
                            item
                          )
                        ) +
                        "\n        " +
                        _vm._s(item.base_unit_title) +
                        "\n      "
                    ),
                  ]),
                  _vm._v("\n      " + _vm._s(item.ingredient_title) + "\n    "),
                ]
              },
            },
            {
              key: "cell(amount_needed)",
              fn: function (ref) {
                var item = ref.item
                return [
                  item.amount_needed !== item.amount_shopping
                    ? _c(
                        "div",
                        { staticClass: "float-left item-original-amount" },
                        [
                          _vm._v(
                            "\n        (" +
                              _vm._s(
                                _vm.formatAmountNeeded(
                                  item.amount_needed,
                                  "amount_needed",
                                  item
                                )
                              ) +
                              ")\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.formatAmountNeeded(
                          item.amount_shopping,
                          "amount_needed",
                          item
                        )
                      ) +
                      "\n    "
                  ),
                ]
              },
            },
            {
              key: "cell(actions)",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "b-btn-group",
                    [
                      item.is_shopped && _vm.canEdit
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "save-row-toggle",
                              attrs: {
                                size: "xs",
                                variant: "primary",
                                disabled: item._updating,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleIsShopped(item)
                                },
                              },
                            },
                            [
                              !item._updating
                                ? _c("i", { staticClass: "fas fa-undo" })
                                : _vm._e(),
                              _vm._v(" "),
                              item._updating
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "light" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.is_shopped && _vm.canEdit
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "save-row-toggle",
                              attrs: {
                                size: "xs",
                                variant: "success",
                                disabled: item._updating,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleIsShopped(item)
                                },
                              },
                            },
                            [
                              !item._updating
                                ? _c("i", { staticClass: "fas fa-check" })
                                : _vm._e(),
                              _vm._v(" "),
                              item._updating
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "light" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { size: "xs" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleDetails(item)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-edit" })]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "table-busy",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "text-center text-danger my-2" },
                    [
                      _c("b-spinner", { staticClass: "align-middle" }),
                      _vm._v(" "),
                      _c("strong", [_vm._v("Lade Einkaufsliste...")]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "empty",
              fn: function () {
                return [_c("h4", [_vm._v("Die Einkaufliste ist leer.")])]
              },
              proxy: true,
            },
            {
              key: "row-details",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("ItemDetailsComponent", {
                    attrs: {
                      item: item,
                      "filter-options": _vm.filterOptions,
                      "can-edit": _vm.canEdit,
                      "api-url": _vm.apiUrl,
                    },
                  }),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "top-row" }, [
            _c(
              "td",
              { attrs: { id: "shopping-place-filter" } },
              [
                _c("b-form-select", {
                  attrs: {
                    size: "sm",
                    options: _vm.filterOptions.shopping_places,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c("b-form-select-option", { attrs: { value: "" } }, [
                            _vm._v("---"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.filters.shopping_place,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "shopping_place", $$v)
                    },
                    expression: "filters.shopping_place",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "d-none d-md-table-cell" },
              [
                _c("b-form-select", {
                  attrs: {
                    size: "sm",
                    options: _vm.filterOptions.ingredient_categories,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c("b-form-select-option", { attrs: { value: "" } }, [
                            _vm._v("---"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.filters.ingredient_category,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "ingredient_category", $$v)
                    },
                    expression: "filters.ingredient_category",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { id: "ingredient-filter" } },
              [
                _c("b-form-input", {
                  attrs: {
                    size: "sm",
                    placeholder: "Zutat suchen...",
                    debounce: "200",
                  },
                  model: {
                    value: _vm.filters.ingredient_title,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "ingredient_title", $$v)
                    },
                    expression: "filters.ingredient_title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "d-none d-sm-table-cell" },
              [
                _c("b-form-input", {
                  attrs: { size: "sm", debounce: "200" },
                  model: {
                    value: _vm.filters.amount_needed,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "amount_needed", $$v)
                    },
                    expression: "filters.amount_needed",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "d-none d-sm-table-cell" },
              [
                _c("b-form-input", {
                  attrs: { size: "sm", debounce: "200" },
                  model: {
                    value: _vm.filters.base_unit_title,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "base_unit_title", $$v)
                    },
                    expression: "filters.base_unit_title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "d-none d-lg-table-cell" },
              [
                _c("b-form-select", {
                  attrs: {
                    size: "sm",
                    options: _vm.filterOptions.ingredient_perishable,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c("b-form-select-option", { attrs: { value: "" } }, [
                            _vm._v("---"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.filters.ingredient_perishable,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "ingredient_perishable", $$v)
                    },
                    expression: "filters.ingredient_perishable",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "d-none d-lg-table-cell" },
              [
                _c("b-form-select", {
                  attrs: {
                    size: "sm",
                    options: _vm.filterOptions.customs_categories,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c("b-form-select-option", { attrs: { value: "" } }, [
                            _vm._v("---"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.filters.customs_category,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "customs_category", $$v)
                    },
                    expression: "filters.customs_category",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("td", { staticClass: "d-none d-sm-table-cell" }, [_vm._v(" ")]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }